import styled from "styled-components";

export const List = styled.ul`
  margin-left: calc(var(--unit) * 4);
`;
